<div class="mobile mobile-bar">
  <button (click)="toggleNav($event)" class="simple-btn nav-toggle">
    <svg
      class
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <use [attr.xlink:href]="SvgSpriteIcon.Menu"></use>
    </svg>
  </button>

  <div class="logo-top">
    <ng-content select="[logo-top]"/>
  </div>
</div>

<nav>
  <div class="mobile inner-bar">
    <ng-content select="[logo-small]"/>
    <button (click)="closeNav()" class="simple-btn">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <use [attr.xlink:href]="SvgSpriteIcon.ChevronLeft"></use>
      </svg>
    </button>
  </div>

  @for (button of navButtons(); track button.target) {
    <lib-icon-button
      appTrackEvent="VeiwChanged" [eventProperties]="{pageView: button.label,  url: button.target}"
      [icon]="button.icon"
      [label]="button.label"
      [routerLink]="button.target"
      [routerLinkActiveOptions]="button.options || { exact: false }"
      routerLinkActive="active"
      (click)="closeNav()"
    />
  }

  <div class="logo-side">
    <ng-content select="[logo-side]"/>
  </div>

  <div class="extra-btn">
    <ng-content select="[extra-btn]"/>
  </div>
</nav>
